import React from "react";
import { Trash2 } from "lucide-react";
import { ShapeDeleteControlProps } from "./types";
import { ShapeControlButton } from "./ShapeControlButton";
import { useEditorShortcuts } from "../../../shortcuts/EditorShortcutContext/useEditorShortcuts";

export const ShapeControlDelete: React.FC<ShapeDeleteControlProps> = ({
  onDelete,
}) => {
  const { shortcuts } = useEditorShortcuts();

  return (
    <ShapeControlButton
      className="text-red-500"
      onClick={() => onDelete()}
      title={"Delete"}
      icon={Trash2}
      shortcut={shortcuts.shapeSelection.delete}
    />
  );
};
